"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const defaultLinks = [];
  const itemsToRender = menuItems && menuItems.length > 0 ? menuItems : defaultLinks;
  const midPoint = Math.ceil(itemsToRender.length / 2);
  const col1Items = itemsToRender.slice(0, midPoint);
  const col2Items = itemsToRender.slice(midPoint);
  if (loading) {
    return <>
        <div className="space-y-4">
          {[1, 2, 3].map(i => <div key={i} className="h-4 w-24 bg-primary/5 animate-pulse rounded-md" data-index={i} />)}
        </div>
        <div className="space-y-4">
          {[1, 2, 3].map(i => <div key={i} className="h-4 w-24 bg-primary/5 animate-pulse rounded-md" data-index={i} />)}
        </div>
      </>;
  }
  return <>
      <div className="flex flex-col space-y-4">
        
        <ul className="space-y-3">
          {col1Items.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-[13px] font-mono text-primary/60 transition-colors duration-300 hover:text-primary">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>

      <div className="flex flex-col space-y-4">
        <ul className="space-y-3">
          {col2Items.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-[13px] font-mono text-primary/60 transition-colors duration-300 hover:text-primary">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </>;
}
export default function PulseMetricsFooter() {
  const currentYear = new Date().getFullYear();
  return <footer id="moondos-footer" className="bg-background text-primary border-t border-primary/5 relative overflow-hidden">
      <div className="container mx-auto px-6 py-20 relative z-10">
        

        <Separator className="bg-primary/10" />

        <div className="pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-[11px] font-mono text-primary/30 uppercase tracking-widest">
          <p>
            &copy; {currentYear} Moondos Media. All rights reserved.
          </p>
          <div className="flex items-center gap-8">
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Privacy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Terms
            </Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Cookies
            </Link>
            <Button asChild variant="ghost" size="icon" className="size-4 p-0 text-primary/30 hover:text-primary hover:bg-transparent transition-colors duration-300">
              <Link to="https://instagram.com/moondos.media" newTab aria-label="Instagram">
                <Instagram className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </footer>;
}